import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import servicioHttp from "../servicio/ServicioHttp";
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import ServicioArchivos from '../servicio/ServicioArchivos';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import servicioFormatos from '../servicio/ServicioFormatos';
import { Paginator } from 'primereact/paginator';
export class DetalleMovimientos extends React.Component {

    constructor(props) {
        super(props)
        const { id } = this.props.location.state;
        this.state = {
            paginacion: { registrosPorPagina: 20 },
            idsenube: 0,
            tcLote: {},
            resumenMovimientos: []

        }


        let { tcLote } = this.state;
        tcLote.id = id.id;
        tcLote.registroPatronal = id.registroPatronal;
        tcLote.loteIdImss = id.loteIdImss;
        tcLote.fechaTransaccion = id.fecha;
        tcLote.fechaRespuesta = id.fecha;
        tcLote.nombre = id.razonSocial;
        
    }

    componentDidMount() {
        let { tcLote } = this.state;
        this.buscarMovimientos();
        servicioHttp
            .consumirPostHttp("movimientos/resumen_movimientos.json", tcLote)
            .then((response) => {
                this.setState({ resumenMovimientos: response.data.lista });
            })
            .catch((error) => { });

    }

    restricciones =()=> {
        let { paginacion, tcLote} = this.state;
        paginacion.restriccionesDinamicas = [];
        paginacion.restriccionesDinamicas.push({
            tipoRestriccion: "eq",
            nombrePropiedad: "alias_ttLoteSolicitudIdse.id",
            valorPropiedad: tcLote.id,
        });


    }
    buscarMovimientos = () => {
     this.restricciones();
        let { paginacion } = this.state;
         servicioHttp
            .consumirPostHttp("movimientos/consultar_detalle_movimientos.json", paginacion)
            .then((response) => {
                this.setState({ paginacion: response.data.objeto });
            })
            .catch((error) => { });
    }
    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first, paginacion });
        this.buscarMovimientos();
    }

    plantillaTipoTrabajador(rowData, column) {
        if (column.rowData.tipoTrabajador === "0")
            return <p >{"Permanente"}</p>
        if (column.rowData.tipoTrabajador === "1")
            return <p >{"Eventual"}</p>
        if (column.rowData.tipoTrabajador === "2")
            return <p >{"Eventual de la Construcción"}</p>
    }

    plantillaTipoMovimiento = (rowData, column) => {
        if (rowData.tipoMovimiento === "08")
            return <div>Reingreso</div>;
        if (rowData.tipoMovimiento === "07")
            return <div>Modificación</div>;
        if (rowData.tipoMovimiento === "02")
            return <div>Baja</div>;
    }

    plantillaTipoSalario = (rowData, column) => {
        if (rowData.tipoSalario === "0")
            return <div>Salario Fijo</div>;
        if (rowData.tipoSalario === "1")
            return <div>Salario Variable</div>;
        if (rowData.tipoSalario === "2")
            return <div>Salario Mixto</div>;
    }

    plantillaJornadaReducida = (rowData, column) => {
        if (rowData.jornadaReducida === "0")
            return <div>Jornada Normal</div>;
        if (rowData.jornadaReducida === "1")
            return <div>Un día</div>;
        if (rowData.jornadaReducida === "2")
            return <div>Dos días</div>;
        if (rowData.jornadaReducida === "3")
            return <div>Tres días</div>;
        if (rowData.jornadaReducida === "4")
            return <div>Cuatro días</div>;
        if (rowData.jornadaReducida === "5")
            return <div>Cinco días</div>;
        if (rowData.jornadaReducida === "6")
            return <div>Jornada Reducida</div>;
    }

    descargarAfil(elemento) {
        ServicioArchivos.descargaArchivo("/documentos/afil_individual.json", { id: elemento.id });
    }

    plantillaDescargaAfil(rowData, column) {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-2">
                    <Button
                        label="Afil"
                        type="button"
                        icon="pi-md-folder"
                        onClick={() => this.descargarAfil(rowData)}
                        className="p-button-info"
                    ></Button>
                </div>
            </div>
        );
    }

    render() {
        let { paginacion, resumenMovimientos, tcLote ,idsenube} = this.state;
        let headerGroup = <ColumnGroup>
            <Row>
                <Column header="Movimientos" rowSpan={3} />
                <Column header="Errores" rowSpan={3} />

            </Row>
            <Row>
                <Column header="Bajas" colSpan={3} />
                <Column header="Modificaciones" colSpan={3} />
                <Column header="Reingresos" colSpan={3} />
            </Row>
            <Row>
                <Column header="movimientos" />
                <Column header="correcto" />
                <Column header="error" />

                <Column header="movimientos" />
                <Column header="correcto" />
                <Column header="error" />

                <Column header="movimientos" />
                <Column header="correcto" />
                <Column header="error" />

            </Row>
        </ColumnGroup>;
        return (<div className="p-grid">

            <h1>Detalle de movimientos</h1>

            <div className="p-col-12 p-md-1">
                <label></label>
            </div>
            <div className="p-col-12 p-md-2">
                <Link to="/idsenube/bienvenido/consultamovimientosrp"><Button className="p-button-info" icon="pi-md-arrow-back" label="Regresar">Regresar</Button></Link>
            </div>
            <div className="p-col-12">
                <div className="card card-w-title">
                    <div className="p-fluid p-grid">
                        <div className="p-col-12 p-md-12">
                            <label>Lote: {tcLote.loteIdImss}</label>

                        </div>
                        <div className="p-col-12 p-md-12">
                            <label>Tipo de Lote:</label>

                        </div>
                        <div className="p-col-12 p-md-12">
                            <label>Registro Patronal: {tcLote.registroPatronal}</label>

                        </div>
                        <div className="p-col-12 p-md-12">
                            <label>Nombre: {tcLote.nombre}</label>

                        </div>
                        <div className="p-col-12 p-md-12">
                            <label>Fecha de Transacción: {servicioFormatos.formatearFecha(tcLote.fechaTransaccion)}</label>

                        </div>
                        <div className="p-col-12 p-md-12">
                            <label>Fecha de Respuesta: {servicioFormatos.formatearFecha(tcLote.fechaRespuesta)}</label>

                        </div>
                        <div>
                            <DataTable
                                value={resumenMovimientos}
                                editable={true}
                                selectionMode="single"
                                responsive={true}
                                header="Total Movimientos"
                                headerColumnGroup={headerGroup}
                            >

                                <Column

                                    field="totalMovimientos"
                                    autoLayout={true}
                                />
                                <Column

                                    field="totalErrores"
                                    autoLayout={true}
                                />
                                <Column

                                    field="totalBajas"
                                    autoLayout={true}
                                />

                                <Column

                                    field="correctosBaja"
                                    autoLayout={true}
                                />

                                <Column

                                    field="erroresBaja"
                                    autoLayout={true}
                                />

                                <Column

                                    field="totalModificaciones"
                                    autoLayout={true}
                                />

                                <Column

                                    field="correctosModificaciones"
                                    autoLayout={true}
                                />

                                <Column

                                    field="erroresModificaciones"
                                    autoLayout={true}
                                />

                                <Column

                                    field="totalReingresos"
                                    autoLayout={true}
                                />

                                <Column

                                    field="correctosReingresos"
                                    autoLayout={true}
                                />

                                <Column

                                    field="erroresReingresos"
                                    autoLayout={true}
                                />










                            </DataTable>



                        </div>
                    </div>
                </div>

            </div>
            <div className="p-col-12">
                <div className="card card-w-title">
                    <DataTable value={paginacion.datos} selectionMode="single" responsive={true} header="Movimientos" scrollable style={{ width: '1030px' }}>
                        <Column field="nombre" header="Nombre del Trabajador" autoLayout={true} style={{ width: '250px' }} />
                        <Column field="primerApellido" header="Apellido Paterno" autoLayout={true} style={{ width: '200px' }} />
                        <Column field="segundoApellido" header="Apellido Materno" autoLayout={true} style={{ width: '200px' }} />
                        <Column body={this.plantillaTipoMovimiento.bind(this)} header="Tipo Movimiento" autoLayout={true} style={{ width: '150px' }} />
                        <Column body={this.plantillaTipoTrabajador.bind(this)} header="Tipo Trabajador" autoLayout={true} style={{ width: '150px' }} />
                        <Column field={this.plantillaTipoSalario.bind(this)} header="Tipo Salario" autoLayout={true} style={{ width: '150px' }} />
                        <Column body={this.plantillaJornadaReducida.bind(this)} header="Jornada Reducida" autoLayout={true} style={{ width: '150px' }} />
                        <Column field="digitoVerificador" header="Digito Verificadro" autoLayout={true} style={{ width: '150px' }} />
                        <Column field="descripcionError" header="Descripcion Error" autoLayout={true} style={{ width: '300px' }} />
                        <Column field="descripcionErrorAfil" header="Descripción Error Afil" autoLayout={true} style={{ width: '200px' }} />
                        <Column field="claveTrabajador" header="Clave de trabajador" autoLayout={true} style={{ width: '170px' }} />
                        <Column body={this.plantillaDescargaAfil.bind(this)} header="Descarga Afil Individual" autoLayout={true} style={{ width: '170px' }} />
                    </DataTable>
                    <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                </div>
            </div>
        </div>
        );
    }
}